var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-return-to"},[_c('AtomLoadingPrimary',{attrs:{"loading-text":_vm.$t('mReturnTo.message')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }